import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=2c0606d3&scoped=true&"
import script from "./TrainingVideo.vue?vue&type=script&lang=js&"
export * from "./TrainingVideo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&id=2c0606d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0606d3",
  null
  
)

export default component.exports